import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * 활성화된 관리 구분을 조회한다.
   * @author Ju
   * @return {Array} 활성화된 관리 구분 목록
   */
  getActiveManagetypeList() {
    return axios.get(`${baseUrl}/common/obj-type/get-active-managetype-list.do`);
  },
  /**
   * 모든 관리 구분 정보를 조회한다.
   * @author KangBonghun(toto1323)
   * @return {[type]} [description]
   */
  getManagetypeInfo() {
    return axios.get(`${baseUrl}/common/obj-type/get-managetype-info.do`);
  },
};



// WEBPACK FOOTER //
// ./src/api/model/managetype.js